import React from 'react'
import BarLoader from 'react-spinners/BarLoader'

export default function LoaderSpinner(props) {
  return <BarLoader color={'#f59a1c'} size={60} {...props} />
}
